<template>
  <div>
    <el-row :gutter="40" class="group">
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="机台总数" icon="machine" color="#40c9c6" :val="dash.dev" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="任务总数" icon="forecast" color="#f4516c" :val="dash.task" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="共有余额" icon="fee" color="#34bfa3" :val="dash.wallet" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import KxCount from '@/components/Count'

export default {
  name: 'DashboardAdmin',
  components: {
    KxCount
  },
  props: {
    dash: {
      type: Object,
      default() {
        return {}
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 18px;
  .col{
    margin-bottom: 32px;
  }
}
</style>
